module.exports = __webpack_public_path__ + "static/media/temblor-icon-logo.fc9f9519.svg";